




































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BaseApplicationController, WechatController } from '@/services/request.service';
import { ApplicationBriefResponse } from '@/services/__model';
import CompleteScoreModal from '@/components/CompleteScoreModal.vue';
import SiderBarInfo from '@/components/SiderBar.vue';
import Checklist from './components/Checklist.vue';
import MessageList from './components/MessageList.vue';
import UniformList from './components/UniformList.vue';
import BankInfoModal from '@/components/BankInfoModal.vue';
import { getSchoolInfo, isWechat } from '@/utils/utils';
import config from '@/school.config';
import fields from '@/fields.config';
const env: string = process.env.VUE_APP_ENV as string;
import { initWechat, wechatReady } from '@/utils/wechat';

@Component({
  components: {
    SiderBarInfo,
    Checklist,
    MessageList,
    UniformList,
    CompleteScoreModal,
    BankInfoModal,
  },
})
export default class Home extends Vue {
  public studentList: Array<ApplicationBriefResponse> = [];
  public visible: boolean = false;
  public studentId: number = -1;
  public config = config;
  public fields = fields;
  public bankInfoVisible: boolean = false;
  public record: any = {};
  public code: string = '';
  public checkList: any = [];
  public alertList: any = [];
  public get locale(): string {
    return this.$i18n.locale;
  }
  public get school() {
    return getSchoolInfo().shortName;
  }

  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }

  public get isChildRoute(): boolean {
    const routeLength = this.$route.matched.length - 1;
    const lastRoute = this.$route.matched[routeLength];
    return lastRoute.name !== 'home';
  }

  public created(): void {
    this.getApplicationList();
    const el = document.getElementsByClassName('layout-t')[0]!;
    if (el) {
      el.scrollTop = 0;
    }
    this.getCode();
    if (config[getSchoolInfo().shortName].wechat && isWechat() && !this.openid && !this.code) {
      const appid = config[getSchoolInfo().shortName][env].appid;
      const href = window.location.href;
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        href
      )}&response_type=code&scope=snsapi_base#wechat_redirect`;
      window.location.href = url;
    } else if (config[this.school].wechat && isWechat() && !this.openid && this.code) {
      this.getOpenIdByCode();
    }
  }

  public getApplicationList(): void {
    BaseApplicationController.getApplicationList()
      .then(res => {
        this.studentList = res.data ? res.data : [];
        const list = this.studentList.filter(item => item.status === '1117' || item.status === '0000');
        this.alertList = list.map((item: any) => item.name + item.enName);
        this.alertList = this.alertList.join('，');

        this.checkList = [];
        this.studentList.map(item => {
          if (item.status === '1101' || item.status === '1106') {
            this.checkList.push(item.studentId);
          }
        });
        let flag = false;
        for (const item of this.studentList) {
          if (!item.studentId) {
            flag = true;
          }
        }
        this.$store.commit('setDraftFlag', flag);
      })
      .catch(() => {});
  }
  public getCode() {
    let searchURL = window.location.search;
    searchURL = searchURL.substring(1, searchURL.length);
    const query = searchURL.split('&').map(item => item.split('='));
    const tmp = query.filter(item => item[0] === 'code');
    this.code = !!tmp.length && tmp[0].length >= 2 ? tmp[0][1] : '';
  }
  public getOpenIdByCode() {
    WechatController.getAccessToken(this.code).then(res => {
      const wechatInfo = {
        wechatId: res.data.openid,
        expireTime: new Date().getTime() + 24 * 60 * 60 * 1000,
      };
      localStorage.setItem('wechat_' + config[this.school].schoolId, JSON.stringify(wechatInfo));
      const url = window.location.origin + window.location.pathname + window.location.hash;
      window.location.href = url;
    });
  }
  public get openid() {
    const openIdString = localStorage.getItem('wechat_' + config[this.school].schoolId);
    if (openIdString) {
      const { wechatId, expireTime } = JSON.parse(openIdString);
      const now = new Date().getTime();
      if (expireTime >= now) {
        return wechatId;
      } else {
        localStorage.removeItem('wechat_' + config[this.school].schoolId);
        return null;
      }
    }
    return null;
  }
  public jumpToDetail(studentId: string, draftId: string, status: string): void {
    if (studentId && (status === '1101' || status === '1106')) {
      this.$router.push({ name: 'studentDetail', query: { studentId } });
    } else {
      if (studentId && draftId === '') {
        this.$router.push({ name: 'application', query: { studentId } });
      } else {
        this.$router.push({ name: 'application', query: { isDraft: 'true', draftId, studentId } });
      }
    }
  }

  public changeVisible(flag: boolean, id: number): void {
    this.visible = flag;
    this.studentId = id;
  }

  public changeBankInfoVisible(flag: boolean, data?: any): void {
    this.bankInfoVisible = flag;
    if (data) {
      this.record = data;
    }
  }
}
